import { render, staticRenderFns } from "./ReturnabilityDynamicSubHeader.vue?vue&type=template&id=424e5ca8&scoped=true"
import script from "./ReturnabilityDynamicSubHeader.vue?vue&type=script&lang=js"
export * from "./ReturnabilityDynamicSubHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424e5ca8",
  null
  
)

export default component.exports